import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DpadZoneType, ROUTE_PATH } from '@core/constants';
import { getSaucerLogActionByRoute } from '@core/configs';
import { SaucerLogService } from '@core/services/saucer-logs/saucer-log.service';
import SwitchButtonConfig from '@core/models/models/switch-button-config.model';

@Component({
selector: 'caremoni-ui-theme',
templateUrl: './ui-theme.component.html',
styleUrl: './ui-theme.component.scss',
encapsulation: ViewEncapsulation.None
})
export class UIthemeComponent implements OnInit {

    switchButtonConfig: SwitchButtonConfig = new SwitchButtonConfig();
    isDarkMode = true;//Default true
    DpadZoneType = DpadZoneType;
    @Output() onClick = new EventEmitter();

    constructor(
      private router: Router,
      private saucerLogService: SaucerLogService,
    ) { }

    ngOnInit() {
      const theme = localStorage.getItem('theme');
      if(theme) {
        this.isDarkMode = theme === 'dark';
      }
      this.updateTheme();

      const isIPad = /iPad|Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
      if (!isIPad) {
        this.switchButtonConfig.width = "3.2vw";
      }
      this.switchButtonConfig.height = "3.1vh";
      this.switchButtonConfig.sizeHandle = "3vh";
    }
  
    toggleTheme(event: any) {
      this.isDarkMode = !this.isDarkMode;
      localStorage.setItem('theme', this.isDarkMode ? 'dark' : 'light');
      this.updateTheme();
      this.onClick.emit(event);

      // Title Settings contains multiple screens under one route. Each visible screen logs its own dark-mode change.
      if (this.router.url.startsWith(`/${ROUTE_PATH.TITLE_SETTINGS}`)) return;
      // Bathe Management serves ADMISSION/COMMUTE/WEEKLY_ADJUST depending on runtime state, not resolvable from the URL alone -> the screen logs its own dark-mode change.
      if (this.router.url.startsWith(`/${ROUTE_PATH.BATHE_MANAGEMENT}`)) return;

      const content = JSON.stringify({ isDarkMode: this.isDarkMode });
      const matchedAction = getSaucerLogActionByRoute(this.router.url);
      this.saucerLogService.action(
        {
          content
        },
        {
          action: matchedAction?.DARK_MODE
        }
      );
    }
  
    private updateTheme() {
      if (this.isDarkMode) {
        document.body.classList.add('dark');
      } else {
        document.body.classList.remove('dark');
      }
    }

}
